import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin"

gsap.registerPlugin( ScrollToPlugin );
gsap.registerPlugin( ScrollTrigger );
gsap.ScrollTrigger = ScrollTrigger;
gsap.ScrollToPlugin = ScrollToPlugin;
window['ikosGsap'] = gsap;
